import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ProfileService} from 'src/app/shared/services/profile.service';
import {environment} from 'src/environments/environment.prod';
import {Subject} from 'rxjs';
import {debounceTime, map, switchMap} from 'rxjs/operators';

@Component({
    selector: 'app-users-search',
    templateUrl: './users-search.component.html',
    styleUrls: ['./users-search.component.scss'],
    standalone: false
})
export class UsersSearchComponent implements OnInit {
  selectedUsers = [];
  searchUserName = '';
  dropdownUser = false;
  deployUrl;
  users;
  usersBase;
  excludeList = [];
  private search$ = new Subject<boolean>();

  @Input() addMultipleUsers = false;
  @Input() excludeListIn = [];
  @Output() usersSelected = new EventEmitter();
  @Output() userRemoved = new EventEmitter();

  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;
  @ViewChild('inputSearch') inputField: ElementRef;

  constructor(private profileService: ProfileService) {}

  ngOnInit(): void {
    this.deployUrl = environment.deploy_url;
    this.excludeList = [...this.excludeListIn];

    this.search$
      .pipe(
        debounceTime(300),
        switchMap(showDropdown =>
          this.profileService.profilesSearch({q: this.searchUserName}).pipe(
            map((data: any) => ({data, showDropdown})),
          ),
        ),
      )
      .subscribe(({data, showDropdown}) => {
        if (this.excludeListIn.length > 0) {
          this.users = data.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id));
          this.usersBase = this.users;
        } else {
          this.users = data;
          this.usersBase = data;
        }
        if (showDropdown) {
          this.dropdownUser = true;
        }
      });

    this.getUsers(false);
  }

  resetSearch() {
    this.getUsers(false);
    this.users = this.usersBase;
    this.selectedUsers = [];
  }

  getUsers(showDropdown = true) {
    this.search$.next(showDropdown);
  }

  removeSelectedUser(user, index) {
    this.selectedUsers.splice(index, 1);
    this.usersSelected.emit(this.selectedUsers);
    this.userRemoved.emit(user);

    this.excludeList = this.excludeList.filter(item => item.id !== user.id);
    this.users = [...this.usersBase.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id))];
  }

  setUser(user) {
    this.dropdownUser = false;
    this.searchUserName = '';

    if (!this.addMultipleUsers) {
      this.selectedUsers = [];
      this.excludeList = [...this.excludeListIn];
    }

    this.selectedUsers.push(user);
    this.excludeList.push(user);

    this.users = [...this.usersBase.filter(item1 => !this.excludeList.some(item2 => item2.id === item1.id))];

    this.usersSelected.emit(this.selectedUsers);
  }

  getImagePath() {
    return this.deployUrl + 'assets/icons/cancel-icon.svg';
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInsideDropdown = this.dropdownMenu?.nativeElement.contains(event.target);
    const clickedInsideInput = this.inputField?.nativeElement.contains(event.target);

    if (!clickedInsideDropdown && !clickedInsideInput) {
      this.dropdownUser = false;
    }
  }
}
